import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Config } from '../config/env.config';
import { contentHeaders } from 'common/headers';
import * as _ from 'lodash';

@Injectable()
export class InviteUserUnguardedService {

    private rootUrl: string = 'invite-user';

    constructor(
      private http: HttpClient,
      private router: Router,
    ) {}


    fetch(token: string): Observable<any> {
        return this.http.get(`${Config.API}/${this.rootUrl}/${token}`)
            ;
    }

    accept(token: string, password: string, password_confirmation: string, first_name: string, last_name: string): Observable<any> {
      const body = JSON.stringify({
        firstName: first_name,
        lastName: last_name,
        password: password,
        password_confirmation: password_confirmation
      });

      return this.http.post(`${Config.API}/${this.rootUrl}/accept/${token}`, body, {headers: contentHeaders})
            ;
    }

}
